// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const likesHistoryConfig = {
    title: 'chart.tiktok.likes_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.tiktok.likes_history_name',
        paid: 'paid_data',
        organic: 'organic_data',
        avg: 'chart.tiktok.likes_history_avg'
    },
    id: 'likes_history',
    color: {
        value: 'red',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.tiktok.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: 'chart.tiktok.likes_history_tooltip',
    size: SIZE_50,
    type: 'chart',
    adsDataToken: 'chart.tiktok.ads_data_tooltip',
    element: LineChart,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS]
};
